import { SideContentProps } from '../../../interfaces/sideContent'
import useId from '../../hooks/useId'
import { SideContentBox, SideContentWrapper } from './ItemCard.styles'
import SideItem from './SideItem'

const SideContent = ({
  area,
  data,
  items = [],
  standalone = false,
  className = '',
  'data-testid': testid
}: SideContentProps) => {
  const { getTestId } = useId(testid)
  const isFloated = items.some(({ float }) => float)
  const itemsList = {
    start: items?.filter(({ side = 'start' }) => side === 'start'),
    center: items?.filter(({ side }) => side === 'center'),
    end: items?.filter(({ side }) => side === 'end')
  }

  return (
    <SideContentWrapper
      className={`SideContent ${className}`}
      area={area}
      standalone={standalone}
      float={isFloated}>
      <SideContentBox className="SideContentStart">
        {itemsList.start.map(({ ...item }, index) => {
          const itemKey = `item-${index}`
          return (
            <SideItem
              {...item}
              key={itemKey}
              data={data}
              data-testid={getTestId(itemKey)}
            />
          )
        })}
      </SideContentBox>
      <SideContentBox className="SideContentCenter">
        {itemsList.center.map(({ ...item }, index) => {
          const itemKey = `item-${index}`
          return (
            <SideItem
              {...item}
              key={itemKey}
              data={data}
              data-testid={getTestId(itemKey)}
            />
          )
        })}
      </SideContentBox>
      <SideContentBox className="SideContentRight">
        {itemsList.end.map(({ ...item }, index) => {
          const itemKey = `item-${index}`
          return (
            <SideItem
              {...item}
              key={itemKey}
              data={data}
              data-testid={getTestId(itemKey)}
            />
          )
        })}
      </SideContentBox>
    </SideContentWrapper>
  )
}

export default SideContent
